import { Link } from "@inertiajs/react";
import { Anchor, Box, Divider, Group, Image, Stack, Text } from "@mantine/core";
import { terms_of_uses_path } from "../../routes";

export function Footer({ version }: { version: string }) {
  return (
    <Stack h="100%" justify="center" align="center">
      <Group w="100%" align="center">
        <Box flex={1} />
        <Group gap="xl">
          <Image h={13} w="auto" fit="contain" src="/footer-image.png" />
          <Text fw={700} fz="xs">
            Zürcher Lehrbetriebsverband ICT
          </Text>
          <Divider color="zli-orange" orientation="vertical" />
          <Text fz="xs">Edenstrasse 20</Text>
          <Divider color="zli-orange" orientation="vertical" />
          <Text fz="xs"> 8045 Zürich</Text>
          <Divider color="zli-orange" orientation="vertical" />
          <Anchor href="tel:+41445528200" fz="xs">
            T 044 552 8200
          </Anchor>
          <Divider color="zli-orange" orientation="vertical" />
          <Anchor href="mailto:info@zli.ch" fz="xs">
            info@zli.ch
          </Anchor>
          <Divider color="zli-orange" orientation="vertical" />
          <Anchor href="https://www.zli.ch" target="_blank" fz="xs">
            www.zli.ch
          </Anchor>
          <Divider color="zli-orange" orientation="vertical" />
          <Anchor component={Link} href={terms_of_uses_path()} fz="xs">
            Nutzungsbedingungen
          </Anchor>
        </Group>
        <Group justify="end" flex={1}>
          <Text size="xs" mr="md">{`Version: v${version}`}</Text>
        </Group>
      </Group>
    </Stack>
  );
}
